import Vue from 'vue';
import Router from 'vue-router';
import Playground from './components/Playground.vue';
import store from './store'

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Playground,
      beforeEnter: (to, from, next) => {
        store.dispatch("showDocumentation", false);
        next();
      }
    },
    {
      path: '/docs/:documentation',
      component: Playground,
      beforeEnter: (to, from, next) => {
        store.dispatch("showDocumentation", true);
        next();
      }
    },,
    {
      path: '/snippets/:snippet',
      component: Playground,
    },
  ],
});
